// services/functions/listUnlockCodeRedemptions.ts — typed wrapper
// around the listUnlockCodeRedemptions callable. Returns the audit
// history for a single unlock code (newest first).

import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

interface Input {
  codeHashPrefix: string;
  limit?: number;
}

export interface UnlockCodeRedemption {
  /** ISO 8601. */
  redeemedAt: string;
  ownerKind: 'uid' | 'install';
  /** Firebase Auth uid OR device install id, depending on ownerKind. */
  ownerId: string;
  productIds: string[];
  /** Signed-in caller at redemption time. Independent of ownerKind -
   *  may be present even when ownerKind === 'install'. */
  redeemedByUid?: string | null;
}

interface Output {
  redemptions: UnlockCodeRedemption[];
}

const callable = httpsCallable<Input, Output>(
  functions,
  'listUnlockCodeRedemptions',
);

export async function listUnlockCodeRedemptions(
  input: Input,
): Promise<UnlockCodeRedemption[]> {
  const res = await callable(input);
  return res.data.redemptions ?? [];
}
